export const styles = {
  root: (show: boolean) => ({
    padding: '0 13px',
    opacity: show ? 1 : 0,
    transform: show ? 'translateY(0)' : 'translateY(-5px)',
    transition: 'opacity 0.25s ease, transform 0.25s ease',
  }),
  container: {
    width: '100%',
    backgroundColor: '#EEF1FF',
    borderRadius: '8px',
    padding: '4px 6px',
    flexWrap: 'wrap',
    alignItems: 'center',
    display: 'flex',
    gap: '5px',
  },
  text: {
    fontSize: '8px',
    fontFamily: 'Inter',
    lineHeight: '146%',
    color: '#4D6EF5',
  },
  iconBox: {
    fontSize: '8px',
    fontFamily: 'Inter',
    lineHeight: '146%',
    color: '#4D6EF5',
    backgroundColor: '#FFF',
    boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.12), 0px 1px 2px rgba(0, 0, 0, 0.08)',
    borderRadius: '3px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '16px',
    height: '16px',
  },
} as const;
